export const VOUCHER_VALIDATE_REQUEST = 'VOUCHER_VALIDATE_REQUEST'
export const VOUCHER_VALIDATE_SUCCESS = 'VOUCHER_VALIDATE_SUCCESS'
export const VOUCHER_VALIDATE_FAIL = 'VOUCHER_VALIDATE_FAIL'
export const VOUCHER_VALIDATE_RESET = 'VOUCHER_VALIDATE_RESET'
export const VOUCHER_REMOVE = 'VOUCHER_REMOVE'
